import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

/** Surface Card (Figma 66:13915): container bg/surface, radius/md. `padded` = 12px padding + 16px gap; `flush` = không padding/gap. */
const SurfaceCard = React.forwardRef(({ variant = 'padded', children, sx, ...props }, ref) => (
  <Box
    ref={ref}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      overflow: 'hidden',
      bgcolor: 'var(--color-bg-surface)',
      borderRadius: 'var(--radius-md)',
      ...(variant === 'padded' && { p: 'var(--space-12)', gap: 'var(--space-16)' }),
      ...sx
    }}
    {...props}
  >
    {children}
  </Box>
))

SurfaceCard.displayName = 'SurfaceCard'

SurfaceCard.propTypes = {
  variant: PropTypes.oneOf(['padded', 'flush']),
  children: PropTypes.node,
  sx: PropTypes.object
}

export default SurfaceCard
